import { render, staticRenderFns } from "./DragAndDropQuestion.vue?vue&type=template&id=7d0c0e1d&scoped=true"
import script from "./DragAndDropQuestion.vue?vue&type=script&lang=js"
export * from "./DragAndDropQuestion.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropQuestion.vue?vue&type=style&index=0&id=7d0c0e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0c0e1d",
  null
  
)

export default component.exports